import axios from 'axios';
import store from '@/store'

// set VUE_APP_API_HOST_DOMAIN in .env to point the site at another backend
export const API_URL = process.env.VUE_APP_API_HOST_DOMAIN || 'https://dev.paron-card.gr';
// Uploaded images live on the main server, so they keep loading when the API points at a
// local backend (which has the database but not the uploads folder).
export const IMAGE_URL = process.env.VUE_APP_IMAGE_HOST_DOMAIN || 'https://dev.paron-card.gr';

const formDataHeaders = {
    'Content-Type': 'multipart/form-data'
}
const headers = {
    'Content-Type': 'application/json; charset=utf-8'
}

// The backend reports most failures as HTTP 200 with a body like {"error": "..."} or {"500": "..."}
const ERROR_KEYS = ['400', '403', '404', '500', 'error']

function bodyError(data) {
    if (!data || typeof data !== 'object' || Array.isArray(data)) {
        return null
    }
    const key = ERROR_KEYS.find(errorKey => data[errorKey])
    return key ? String(data[key]) : null
}

export default {
    post(urlPath, data, customHeaders) {
        return this.request(urlPath, customHeaders || headers, 'POST', data);
    },
    get(urlPath) {
        return this.request(urlPath, headers, 'GET', null);
    },
    postFormData(urlPath, formData) {
        return this.request(urlPath, formDataHeaders, 'POST', formData)
    },
    // full URL of an image uploaded to the backend, or null
    imageUrl(image) {
        return image && image.imageName ? `${IMAGE_URL}/uploads/images/${image.imageName}` : null
    },
    request(urlPath, baseHeaders, method, data, retried) {
        method = method || 'POST';
        data = data || {};
        const apiToken = localStorage.getItem('paron-website-api-token')
        const headers = apiToken
            ? { ...baseHeaders, 'Authorization': 'Bearer ' + apiToken }
            : baseHeaders
        return axios({
            url: API_URL + urlPath,
            data,
            method,
            headers
        }).then(response => {
            const contentType = response.headers['content-type'];
            if (!contentType || contentType.indexOf('application/json') === -1) {
                return undefined
            }
            const message = bodyError(response.data)
            if (message) {
                const error = new Error(message)
                error.response = response
                throw error
            }
            return response.data
        }).catch(error => {
            // An expired dealer session: drop it, then ask once more as a visitor, so public pages
            // (partners, teams) still load. Requests only a dealer may make fail as before.
            if (error.response && error.response.status === 401 && apiToken) {
                store.dispatch('logout')
                if (!retried) {
                    return this.request(urlPath, baseHeaders, method, data, true)
                }
            }
            throw error
        });
    }
};
